"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ratio = void 0;
/**
 * A relationship of two Quantity values - expressed as a numerator and a denominator.
 */
var Ratio = /** @class */ (function () {
    function Ratio() {
    }
    return Ratio;
}());
exports.Ratio = Ratio;
